import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { CustomerViewExtraDropdown } from './CustomerViewExtraDropdown';
import React from 'react';
import { Tooltip } from 'antd';
export const CustomerViewExtra = (props) => {
    const { id, customer, shardName } = props;
    return customer ?
        React.createElement("div", { className: 'customer-view-extra', id: id },
            React.createElement(Tooltip, { title: ADMIN_DASHBOARD_COPY.METRIC_TOOLTIP_GLOBAL_KEY },
                React.createElement("span", { className: 'customer-view-extra-metric' }, customer === null || customer === void 0 ? void 0 : customer.globalKey)),
            React.createElement(Tooltip, { title: ADMIN_DASHBOARD_COPY.METRIC_TOOLTIP_LOCAL_KEY },
                React.createElement("span", { className: 'customer-view-extra-metric' }, customer === null || customer === void 0 ? void 0 : customer.id)),
            React.createElement(Tooltip, { title: ADMIN_DASHBOARD_COPY.METRIC_TOOLTIP_SHARD },
                React.createElement("span", { className: 'customer-view-extra-metric' }, shardName !== null && shardName !== void 0 ? shardName : ADMIN_DASHBOARD_COPY.SHARD_NAME_NONE)),
            React.createElement(CustomerViewExtraDropdown, { customer: customer, shardName: shardName })) :
        null;
};
